import {
  ApacHotelsComponent,
  useApacHotelsStyles,
} from "@apac/components/hotels";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { toStarRating } from "@b2bportal/core-utilities";
import { HotelStarRating as StarRatingEnum } from "@b2bportal/lodging-api";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./styles.module.scss";

export type HotelStarRatingProps = PlatformComponentProps & {
  starRating?: StarRatingEnum;
};

export const HotelStarRating = ({
  starRating,
  className,
}: HotelStarRatingProps) => {
  const COMPONENT_KEY = ApacHotelsComponent.HotelStarRating;
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  if (!starRating || starRating === StarRatingEnum.NotAvailable) {
    return null;
  }

  return (
    <div className={clsx(block, className)}>
      <Icon iconName={IconNameEnum.starFilled} useCurrentColor={false} />
      {`${toStarRating(starRating)}/5`}
    </div>
  );
};
